import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/roles',
    name: 'roles',
    component: () => import('@/views/pages/roles/RolesList.vue'),
    meta: {
      pageTitle: 'Roles',
      breadcrumb: {
        label: 'Roles'
      },
      roles: [ROLES.ADMIN]
      // verticalMenu: {
      //   title: 'Roles',
      //   icon: 'UsersIcon',
      //   parent: 'settingsGroup'
      // }
    }
  },
  {
    path: '/roles/create',
    name: 'create_roles',
    component: () => import('@/views/pages/roles/CreateRole.vue'),
    meta: {
      pageTitle: 'Add New Role',
      breadcrumb: {
        label: 'Add New Role',
        parent: 'roles'
      },
      roles: [ROLES.ADMIN]
    }
  },
  {
    path: '/roles/:id/',
    name: 'edit_roles',
    component: () => import('@/views/pages/roles/EditRole.vue'),
    meta: {
      pageTitle: 'Edit Role',
      breadcrumb: {
        label: 'Edit Role',
        parent: 'roles'
      },
      roles: [ROLES.ADMIN]
    }
  },
  {
    path: '/roles/:id/permissions',
    name: 'edit_permissions',
    component: () => import('@/views/pages/roles/RolePermissionsList.vue'),
    meta: {
      pageTitle: 'Edit Permissions',
      breadcrumb: {
        label: 'Edit Permissions',
        parent: 'roles'
      },
      roles: [ROLES.ADMIN]
    }
  },
  {
    path: '/roles/add/permission',
    name: 'create_permission',
    component: () => import('@/views/pages/roles/CreatePermissions.vue'),
    meta: {
      pageTitle: 'Create Permissions',
      breadcrumb: {
        label: 'Create Permissions',
        parent: 'roles'
      },
      roles: [ROLES.ADMIN]
    }
  }
];
